import { motion } from "framer-motion";
import { Banknote, DollarSign, Copy, Check, Smartphone } from "lucide-react";
import { useState } from "react";
import { BUSINESS } from "@/lib/business";

const METHODS = [
  { key: "cashapp", label: "Cash App", value: BUSINESS.cashApp, url: BUSINESS.cashAppUrl, icon: DollarSign, color: "#00D632" },
  { key: "applepay", label: "Apple Pay", value: BUSINESS.applePay, url: null, icon: Smartphone, color: "#000000" },
  { key: "cash", label: "Cash", value: "Pay at pickup", url: null, icon: Banknote, color: "#556B2F" },
];

export const Payments = () => {
  const [copied, setCopied] = useState("");

  const copy = (key, value) => {
    navigator.clipboard?.writeText(value);
    setCopied(key);
    setTimeout(() => setCopied(""), 1500);
  };

  return (
    <section id="pay" data-testid="payments-section" className="py-20 sm:py-28 bg-cream">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-sm tracking-[0.25em] uppercase text-brand font-bold">Payment</span>
          <h2 className="mt-3 font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-ink">
            Pay the easy way
          </h2>
          <p className="mt-4 text-inkmuted">No app checkout needed — just use your favorite method below.</p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {METHODS.map((m, i) => (
            <motion.div
              key={m.key}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08 }}
              data-testid={`payment-${m.key}`}
              className="bg-white rounded-3xl border border-line p-7 flex flex-col items-start"
            >
              <div className="w-12 h-12 rounded-xl flex items-center justify-center text-white" style={{ backgroundColor: m.color }}>
                <m.icon size={22} />
              </div>
              <h3 className="mt-5 font-serif text-lg font-semibold text-ink">{m.label}</h3>
              <p className="mt-1 text-brand font-bold break-all">{m.value}</p>
              {m.url ? (
                <a href={m.url} target="_blank" rel="noreferrer" data-testid={`payment-link-${m.key}`} className="mt-4 text-sm font-semibold text-olive hover:underline">
                  Open {m.label} →
                </a>
              ) : (
                m.key !== "cash" && (
                  <button onClick={() => copy(m.key, m.value)} className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-inkmuted hover:text-brand">
                    {copied === m.key ? <Check size={15} /> : <Copy size={15} />} {copied === m.key ? "Copied" : "Copy"}
                  </button>
                )
              )}
            </motion.div>
          ))}
        </div>
        <p className="mt-8 text-center text-sm text-inkmuted">
          Please include your name in the payment note so we can match it to your order.
        </p>
      </div>
    </section>
  );
};
